<template>
    <div>
        <treeselect
            valueFormat="object"
            v-model="currentSelected"
            :multiple="false"
            :async="true"
            :load-options="loadOptions"
            :clear-on-select="true"
            ref="select"

            :placeholder="currentLang.placeholder"
            :retryTitle="currentLang.retryTitle"
            :retryText="currentLang.retryText"
            :noOptionsText="currentLang.noOptionsText"
            :noResultsText="currentLang.noResultsText"
            :noChildrenText="currentLang.noChildrenText"
            :searchPromptText="currentLang.searchPromptText"
            :clearValueText="currentLang.clearValueText"
            :clearAllText="currentLang.clearAllText"
        ></treeselect>

        <input type="hidden" :name="name" v-model="encodedData" />
    </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'

import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
    components: {
        Treeselect
    },
    props: {
        lang: {
            required: false,
            type: Object,
        },
        selected: {
            required: false,
            type: Array
        },
        options: {
            required: false,
            type: Array
        },
        name: {
            required: true,
            type: String
        }
    },
    data: function () {
        return {
            currentLang: {
                'placeholder': 'Select...',
                'retryTitle': 'Click to retry',
                'retryText': 'Retry?',
                'noOptionsText': 'No options available.',
                'noResultsText': 'No results found...',
                'noChildrenText': 'No sub-options.',
                'searchPromptText': 'Type to search...',
                'clearValueText': 'Clear value',
                'clearAllText': 'Clear all'
            },
            currentSelected: null,
            currentOptions: []
        }
    },
    methods: {
        loadOptions: _.debounce(({action, searchQuery, callback}) => {
            axios.get(`/api/backend/products?search=${searchQuery}`)
                .then(response => {
                    let options = [];
                    if (response.data.hasOwnProperty('data')) {
                        options = response.data.data.map(i => ({
                            id: `${i.id}`,
                            label: `${i.label}` ,
                        }));
                    }
                    callback(null, options)
                });
        }, 500),
        changeLang() {
            _.forEach(this.lang, (value, key) => {
                this.currentLang[key] = value;
            });
        }
    },
    computed: {
        encodedData() {
            return JSON.stringify(this.currentSelected);
        }
    },
    mounted() {

        this.currentSelected = this.selected.map(i => ({
            id: `${i.id}`,
            label: i.label ? i.label : `${i.title} - ${i.code}`
        }));


        this.changeLang();
    },
    created() {
    }

}
</script>
